<template>
    <v-dialog :value="value" @input="showDialog($event)" :max-width="maxWidth">
        <v-form
            ref="form"
            lazy-validation
            @submit.prevent="submitForm"
        >
            <v-card>
                <v-card-title v-if="title">
                    <span class="headline">{{ title }}</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                    <v-container>
                        <slot></slot>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <slot name="actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="button" text @click="showDialog(false)">Zrušiť</v-btn>
                        <v-btn color="primary" type="submit" text>Uložiť</v-btn>
                    </slot>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },

  watch: {
    value () {
      if (!this.value) {
        this.form.reset()
      }
    }
  },

  computed: {
    form () {
      return this.$refs.form
    }
  },

  methods: {
    submitForm () {
      if (this.form.validate()) {
        this.$emit('save')
      } else {
        console.warn('Form is not valid')
      }
    },
    showDialog (isVisible) {
      this.$emit('input', isVisible)
    }
  }

})
</script>
